export const environment = {
  production: true,

  publicApiUrl: 'https://joga.cz/satsang/backend/index.php/api',
  societyLogoFile: 'logo-cz.png',

  societyName: 'Yoga in Daily Life Czechia',
  societyUrl: '',
  locale: 'en',
  currencySign: 'Kč',
  currencyCode: 'CZK',
  recaptchaSiteKey: ''
};
